export default __webpack_public_path__ + "static/media/device.83a52d72.svg";